import React from "react";

export default function ProductBreadcrumb({ current }) {
  return (
    <p className="text-[13px] font-medium text-muted">
      Product
      <span className="mx-2 text-ink/25" aria-hidden="true">
        /
      </span>
      <span className="text-hint-deep">{current}</span>
    </p>
  );
}
